import React from "react";
import TaskBoard from "../component/TaskBoard";

const TaskBoardContainer = () => (<TaskBoard />)

export default TaskBoardContainer;
